//@flow
import type { ID, Selector } from '../../core/types'
import type { Charity } from './types'
import type { EntityMap } from '../../modules/entities'
import { createSelector } from 'reselect'
import { hget } from '../../modules/hash/index'
import { getDomain } from '../../modules/entities'
import { DOMAIN } from './constants'
import { getUserCharityId } from '../session/index'
import { domains } from '../index'

export const getWizardStep: Selector<number> = hget(DOMAIN, 'step')

export const getUserCharity: Selector<ID> = createSelector(
  getUserCharityId,
  getDomain(domains.CHARITIES),
  (userCharityId: number, allCharities: EntityMap<Charity>) => {
    return !!userCharityId && allCharities[userCharityId.toString()]
  }
)



// WEBPACK FOOTER //
// ./src/services/register-charity/selectors.js